<template>
    <span
            class="bto-sb-tooltip"
            :style="position"
            ref="bto-sb-tooltip"
            v-show="showTooltip"
            @mousenter="showTooltip = false">
       <strong class="bto-sb-tooltip-minfo" v-show="message">{{message}}</strong>
       <strong class="bto-sb-tooltip-minfo" v-show="marketName && outcomeName">{{marketName}}: {{outcomeName}}</strong>
       <strong class="bto-sb-tooltip-oinfo" v-show="oddValue">{{oddValue}}</strong>
        <strong :class="['bto-sb-tooltip-arrow', {'bto-sb-tooltip-arrow-left-pos': message !== ''}]"></strong>
    </span>
</template>

<script>
  import { EventBus } from '../../../services/event-bus-service';

  export default {
    name: 'OddTooltipComponent',
    data() {
      return {
        message: '',
        marketName: '',
        oddValue: '',
        outcomeName: '',
        position: {
          left: 0,
          top: 0
        },
        showTooltip: false
      };
    },
    created() {
      EventBus.$on('showoddmarketpopup', this.handleShowPopup);
      EventBus.$on('hideoddmarketpopup', this.handleHidePopup);
    },
    beforeDestroy() {
      EventBus.$off('showoddmarketpopup', this.handleShowPopup);
      EventBus.$off('hideoddmarketpopup', this.handleHidePopup);
    },
    methods: {
      /**
       * Handler for showoddmarketpopup event
       */
      handleShowPopup(data) {
        if ((typeof data.marketName === 'undefined' || data.outcome.name === '--') && typeof data.message === 'undefined') {
          this.hideTooltip();
          return;
        }
        this.showTooltip = true;
        this.marketName = data.marketName || '';
        this.outcomeName = typeof data.outcome !== 'undefined' ? (data.outcome.enrichedOutcomeName || data.outcome.name) : '';
        this.message = typeof data.message !== 'undefined' ? data.message : '';
        this.oddValue = typeof data.outcome !== 'undefined' ? data.outcome.originalDecimalOutcome : '';
        this.$nextTick(() => {
          this.setPosition(data.e);
          this.$refs['bto-sb-tooltip'].style.opacity = 1;
        });
      },
      /**
       * Handler for hideoddmarketpopup event
       */
      handleHidePopup() {
        this.hideTooltip();
      },
      /**
       * Hide tooltip
       */
      hideTooltip() {
        this.showTooltip = false;
        this.$refs['bto-sb-tooltip'].style.opacity = 0;
        this.message = '';
      },
      /**
       * Set tooltip position
       */
      setPosition(evt) {
        const el = evt.target;
        if (!el) {
          return;
        }
        const mainContainer = document.getElementById('sportbook');
        const mainCCords = mainContainer.getBoundingClientRect();
        const rect = el.getBoundingClientRect();
        this.setTooltipTopPos(rect, mainCCords, evt);
        this.setTooltipLeftPos(el, rect, mainContainer, evt);
      },
      /**
       * Set top position
       * @param rect
       * @param mainCCords
       * @param evt
       */
      setTooltipTopPos(rect, mainCCords, evt) {
        const tooltip = this.$refs['bto-sb-tooltip'].getBoundingClientRect();
        let calculatedTop = rect.top - mainCCords.top;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.message) {
          this.position.top = `${(evt.pageY - mainCCords.top - scrollTop) - (tooltip.height + 15)}px`;
        } else {
          this.position.top = `${calculatedTop - tooltip.height}px`;
        }
      },
      /**
       * Set left position
       * @param el
       * @param rect
       * @param mainContainer
       * @param evt
       */
      setTooltipLeftPos(el, rect, mainContainer, evt) {
        const tooltip = this.$refs['bto-sb-tooltip'];
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        const mainLeftOffset = mainContainer.getBoundingClientRect().left;
        if (this.message) {
          const leftAboveMouse = evt.pageX - (tooltip.offsetWidth / 2) - mainLeftOffset - scrollLeft;
          this.position.left = `${leftAboveMouse}px`;
        } else {
          const leftCenter = rect.left + ((el.offsetWidth - tooltip.offsetWidth) / 2) - mainLeftOffset;
          this.position.left = `${leftCenter}px`;
        }
      }
    }
  };
</script>
